<template>

  <div class="grid-main bg-purple">
    <h2 style="float: left;">用户管理</h2>
    <el-button type="primary" @click="dialogroleAdd=true">新增角色</el-button>
    <div class="table-box" >

      <el-table
        :data="roleList.list"
        height="550"
        border
        style="width: 100%;">
        <el-table-column
          prop="id"
          label="序号"
          width="180">
        </el-table-column>
        <el-table-column
          prop="roleName"
          label="角色名称"
        >
        </el-table-column>


        <el-table-column
          fixed="right"
          label="操作">
          <template slot-scope="scope">
            <el-button
            	type="success"
              size="mini"
              @click="openrole(scope.row.id)">编辑</el-button>
            <el-button

              size="mini"
              type="danger"
              @click="openDelete(scope.row.id)">删除</el-button>
            <el-button
              type="success"
              size="mini"
              @click="openroleMenu(scope.row.id)">分配菜单</el-button>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination
      	v-if="roleList.roleListtotal>10"
        background
        layout="prev, pager, next"
        :page-size="10"
        @current-change="setgetRoleList"
        :total="roleList.roleListtotal">

      </el-pagination>
    </div>

    <el-dialog  :visible.sync="dialogroleAdd" :before-close="dialogroleMenucloseA">
      <el-form ref="form" label-width="150px">

        <el-form-item label="角色名称">
          <el-input v-model="roleAdds.roleName" type="text" placeholder="请输入角色名称："></el-input>
        </el-form-item>


        <el-form-item>
          <el-button type="primary" @click="roleAdd()">确认提交</el-button>

        </el-form-item>
      </el-form>
    </el-dialog>



    <el-dialog :visible.sync="dialogupdatrole" :before-close="dialogroleMenucloseB">
      <el-form ref="form" label-width="150px">


        <el-form-item label="角色名称：">
          <el-input v-model="updateroles.roleName" type="text" placeholder="请输入角色名称："></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="updaterole">确认提交</el-button>

        </el-form-item>
      </el-form>
    </el-dialog>


    <el-dialog :visible.sync="dialogroleMenu" :destroy-on-close="true" :before-close="dialogroleMenucloseC">
      <el-form ref="form" style="width:100%;text-align: left;">
        <el-form-item>
          <el-checkbox-group  v-model="menusids">
            <el-checkbox v-for="Menu in getMenuList" :label="Menu.id" :key="Menu.id">{{Menu.menuName}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item style="    margin-bottom: 0px;">
          <el-button type="primary" @click="roleMenu" style="margin-right: 23px;margin-bottom: 0px;">确认提交</el-button>

        </el-form-item>
      </el-form>
    </el-dialog>
  </div>

  <!--企业修改-->


</template>

<script>
export default {
  name: "Role",

  data() {
    return {
      dialogroleAdd:false,
      //角色列表
      roleList:{
        list:[],
        roleListpage:1,
        roleListtotal:0,
        rolepageSize:10
      },
      //新增角色
      roleAdds:{
        roleName:'',
      },
      //修改角色
      roleid:'',
      updateroles:{
        roleName:'',
      },
      dialogupdatrole:false,

      menusids:[],
      dialogroleMenu:false,
      roleida:'',
      dialogscoreprocess : false,

      getMenuList:[],

    }
  },
  beforeRouteEnter(to, from, next) {

    next((vm) => {

    });
  },
  created() {

  },
  mounted() {
    this.selectgetRoleList();
  },
  methods: {
//角色列表
    selectgetRoleList(){
      let that = this;
      let roledata = {
        page:this.roleList.roleListpage,
        pageSize:10,
      }
      this.$axios.defaults.withCredentials=true;
      this.$axios
        .post('/api/role/getRoleList',roledata)
        .then(function (res) {

          if(res.data.code==200){
            that.roleList.list = res.data.data.list;
            that.roleList.roleListtotal = res.data.data.total;
          }
          else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },


    setgetRoleList(roleListpage){
      this.roleList.roleListpage = roleListpage;
      this.selectgetRoleList();
    },

    //新增角色
    roleAdd(){
      let that = this;
      if (that.roleAdds.roleName == '') {
        that.$message.error('请输入角色名称');
        return false;
      }
      var roleAddsdata = {
        roleName:that.roleAdds.roleName,
      }
      this.$axios
        .post('/api/role/roleAdd', roleAddsdata)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("新增角色失败:"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '新增角色成功',
              type: 'success'
            });
            //  this.show == true;
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });


    },

    selectRoleById(){
      let that = this;
      let updaterolesiddata = {
        id:that.roleid,
      }
      this.$axios
        .post('/api/role/selectRoleById', updaterolesiddata)
        .then(function (res) {
          that.updateroles.roleName = res.data.data.roleName;
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },



    openrole(roleid){
      this.roleid = roleid;
      this.dialogupdatrole = true;
      this.selectRoleById();

    },
    //修改角色
    updaterole(){
      let that = this;
      if (that.updateroles.roleName == '') {
        that.$message.error('请输入角色名称');
        return false;
      }
      let updaterolesdata = {
        id:this.roleid,
        roleName:that.updateroles.roleName,
      }
      this.$axios
        .post('/api/role/update', updaterolesdata)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("修改角色失败:"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '修改角色成功',
              type: 'success'
            });
            //  this.show == true;
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },

    //删除角色

    openDelete(roleid) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.rolebatchDelete(roleid);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    rolebatchDelete(roleid){
      let that = this;
      let roleIdsdata = {
        roleIds:[]
      }
      roleIdsdata.roleIds.push(roleid);
      this.$axios
        .post('/api/role/batchDelete',roleIdsdata)
        .then(function (res) {
          if(res.data.code==200){
            that.$message({
              message: '删除成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    //获取所有菜单
    getMenuByRole(){
      let that = this;
      let MenuByRoledata = {
        roleId: this.roleida
      }
      this.$axios
        .post('/api/role/getMenuByRole',MenuByRoledata)
        .then(function (res) {
          for(var i=0 ; i<res.data.data.length; i++){
            that.menusids[i] = res.data.data[i] .menuId

          }
          console.log(that.menusids)
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },

    //分配菜单
    openroleMenu(roleida){
      this.roleida = roleida;
      this.getMenuByRole();
      this.selectgetMenuList();

      window.setTimeout(() => {
        this.dialogroleMenu = true;
      }, 100);

    },
    dialogroleMenucloseA(){
    	this.dialogroleAdd=false
    },
    dialogroleMenucloseB(){
    	this.dialogupdatrole=false
    },
    dialogroleMenucloseC(){
    	this.dialogroleMenu=false
    },
    //菜单列表
    selectgetMenuList(){
      let that = this;

      this.$axios.defaults.withCredentials=true;
      this.axios
        .get('/api/menu/getMenuList')
        .then(function (res) {

          if(res.data.code==200){
            that.getMenuList = res.data.data;
          }
          else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },



    //分配菜单
    roleMenu(){
      let that = this;
      let roleMenudata = {
        roleId:that.roleida,
        menus:that.menusids
      }

      this.$axios
        .post('/api/role/roleMenu',roleMenudata)
        .then(function (res) {

          if(res.data.code==200){
            that.$message({
              message: '分配成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },




  },

  watch: {

  },
}
</script>

<style scoped>
/deep/ .el-button--primary {
  width: auto!important;
  margin-bottom: 20px;
  margin-top: 20px!important;
  float: right;
}
.el-checkbox{
	width: 21%;
	text-align: left;
	padding-left: 50px;
	box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/view/admin/Role.vue